import React from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { OSH_IMAGES } from "../../lib/worldOsharImages";
import { trackOsharRealEstateView } from "../../utils/analytics";

const features = [
  { icon: "fas fa-vr-cardboard", label: "VR City" },
  { icon: "fas fa-ticket-alt", label: "Events & Games" },
  { icon: "fas fa-store", label: "Shopping Districts" },
  { icon: "fas fa-building", label: "Real Estate" },
  { icon: "fas fa-globe-americas", label: "Open-World Extension" },
];

const OsharHero = () => {
  const bg = OSH_IMAGES.hero;

  return (
    <section className="oshar-hero" aria-label="The World of Oshar">
      <div className="oshar-hero__bg" style={{ backgroundImage: `url(${bg})` }} />
      <div className="oshar-hero__veil" />
      <div className="oshar-hero__glow" />
      <div className="oshar-inner oshar-hero__inner">
        <p className="oshar-hero__eyebrow">Treydora Universe</p>
        <h1 className="oshar-hero__title">THE WORLD OF OSHAR</h1>
        <p className="oshar-hero__lead">
          A living VR metropolis wired into Treydora—where factions meet markets,
          arenas thunder with spectacle, and your holdings echo back into the
          wider RPG economy.
        </p>
        <div className="oshar-hero__ctas">
          <HashLink
            smooth
            to="#oshar-what"
            className="oshar-btn-gold"
            onClick={() =>
              trackOsharRealEstateView({
                cta_id: "world_hero_explore_oshar",
                section: "world_hero",
                destination: "#oshar-what",
              })
            }
          >
            EXPLORE OSHAR
          </HashLink>
          <Link
            to="/world/oshar/real-estate"
            className="oshar-btn-outline"
            onClick={() =>
              trackOsharRealEstateView({
                cta_id: "world_hero_vr_real_estate",
                section: "world_hero",
                destination: "/world/oshar/real-estate",
              })
            }
          >
            VR REAL ESTATE
          </Link>
        </div>
        <ul className="oshar-hero__features" aria-label="Highlights">
          {features.map((f) => (
            <li key={f.label}>
              <i className={f.icon} aria-hidden />
              <span>{f.label}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default OsharHero;
